import React, { FunctionComponent } from "react"
import useDemoAlias from "hooks/ielts/useDemoAlias"

type Props = {
  fontSize?: string
}

const HeadingIeltsElite: FunctionComponent<Props> = ({ fontSize = "20px" }) => {
  const { isMasterclassAlias } = useDemoAlias()
  return (
    <h1 className={`font-bold text-[${fontSize}] text-center mt-8 flex-grow`}>
      {isMasterclassAlias ? "Join Free" : "Book your"}{" "}
      <span className="bg-gradient-to-r from-[#635EFF] via-[#663CFF] to-[#5200FF]  text-white px-3 rounded-3 inline-block skew-x-[-10deg]">
        <span className="inline-block skew-x-[10deg]">IELTS</span>
      </span>{" "}
      MasterClass
    </h1>
  )
}
export default HeadingIeltsElite
